// src/stripe.js
import { loadStripe } from "@stripe/stripe-js";
const key = import.meta.env["VITE_APP_STRIPE_PUB_KEY"];
// Replace with your own Stripe publishable key
const stripePromise = loadStripe(key || "");

export default stripePromise;
